import { Temporal } from 'temporal-polyfill';

import { useState } from 'react';
import { useSession } from './useSession';

/**
 * Retrieves the current acting user's preferred time zone. If they do not
 * have one set, use the browser's guess.
 */
export function useTimeZone() {
  const [timeZone, setTimezone] = useState<string>(useSession().actingUser.timeZone ?? Temporal.Now.timeZoneId());

  return {
    timeZone,
    setTimezone,
  };
}
